import {Table, Tag, Empty, Spin} from "antd";
import {renderDate} from "~/utils";
import {Button, Icon} from "~/components";
import {numberFormat} from "~/utils";
import "../../style/PurchaseOrderTable.scss";

function PurchaseOrderDetail({record, details, isLoading, appData})
{
    const detailColumns = [
        {
            title: 'Mã hàng',
            dataIndex: 'product_code',
            key: 'product_code',
            width: '120px',
        },
        {
            title: 'Tên hàng',
            dataIndex: 'product_name',
            key: 'product_name',
            width: '300px',
            render: (_, item) => (
                <div>
                    <p className="mb-0">{item.product_name} {item.product_attribute && <span className="fw-bold color-blue">{item.product_attribute}</span>}</p>
                </div>
            )
        },
        {
            title: 'Số lượng',
            dataIndex: 'quantity',
            key: 'quantity',
            width: '120px',
            render: (_, item) => (
                (item.unit === 'kg') ? Number(item.quantity/1000).toFixed(2) : item.quantity
            )
        },
        {
            title: 'Đơn vị',
            dataIndex: 'unit',
            key: 'unit',
            width: '120px',
        }
    ];

    const statusInfo = appData['purchaseStatus'][record.status] || { badge: 'default', label: record.status};

    return (
        <div className="purchase-order-details">
            <div className="purchase-order-header">
                <div className="purchase-order-header-left">
                    <div className="purchase-order-code">{record.code}</div>
                    {record.status && <Tag color={statusInfo.badge}>{statusInfo.label}</Tag>}
                </div>
                <div className="purchase-order-header-right">
                    {record.supplier_name && <span>{record.supplier_name}</span>}
                </div>
            </div>
            <div className="purchase-order-meta mb-3">
                {record.purchase_name && <span>Người nhập: <b>{record.purchase_name}</b></span>}
                {record.purchase_date && <span>Ngày nhập: <b>{renderDate(record.purchase_date)}</b></span>}
            </div>
            <div className="purchase-order-table">
                <Spin spinning={isLoading}>
                    {details.length === 0 ? (
                        <Empty description="Chưa có chi tiết" />
                    ) : (
                        <Table
                            columns={detailColumns}
                            dataSource={details.map((detail, index) => ({
                                key: detail.purchase_order_detail_id || index,
                                ...detail
                            }))}
                            pagination={false}
                            size="small"
                        />
                    )}
                </Spin>
            </div>
            <div className="purchase-order-totals">
                <div className="purchase-order-total-row">
                    <span>Tổng số lượng</span>
                    <b>{numberFormat(record.total_quantity_item)} sản phẩm</b>
                </div>
                <div className="purchase-order-total-row">
                    <span>Tổng khỗi lượng</span>
                    <b>{numberFormat(record.total_quantity_weight/1000)} Kg</b>
                </div>
            </div>
            <div className="purchase-order-footer">
                <Button background red>Hủy đơn</Button>
                <Button background white>In</Button>
            </div>
        </div>
    );
}

export default PurchaseOrderDetail;
